(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:request', async (event) => {
    if (window.CART_REDIRECTION_ENABLED) {
      return; 
    }

    // Cancel default cart addition processing
    event.preventDefault();

    try {
      // Convert FormData to array format (expected by AddToCartFlyout)
      const formData = event.detail.form;
      const formDataArray = [];
      for (let [key, value] of formData.entries()) {
        formDataArray.push({ name: key, value: value });
      }

      const submitButton = document.querySelector('button[type="submit"], input[type="submit"]');
      
        const addToCartFlyout = new window.AddToCartFlyout(formDataArray, {
          atcButton: submitButton,
          settings: {
            moneyFormat: window.SHOP_MONEY_FORMAT
          }
        });

        // Wait for AddToCartFlyout completion and return actual response data
        const handleComplete = (completeEvent) => {
          document.removeEventListener('addToCartFlyout:complete', handleComplete);
          document.removeEventListener('addToCartFlyout:error', handleError);
          event.detail.resolve(completeEvent.detail.responseData);
        };

        const handleError = (errorEvent) => {
          document.removeEventListener('addToCartFlyout:complete', handleComplete);
          document.removeEventListener('addToCartFlyout:error', handleError);
          event.detail.reject(errorEvent.detail.error);
        };

        document.addEventListener('addToCartFlyout:complete', handleComplete);
        document.addEventListener('addToCartFlyout:error', handleError);

    } catch (error) {
      console.error('AddToCartFlyout error:', error);
      event.detail.reject(error);
    }
  });

  document.addEventListener('product-form:cart:navigate', (event) => {
    if (!window.CART_REDIRECTION_ENABLED) {
      event.preventDefault();
    }
  });

  document.addEventListener('product-form:submit:success', (event) => {
    if (window.CART_REDIRECTION_ENABLED) {
      window.location.href = window.Theme.routes.cart_url;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pxu-video"] && !Shopify.designMode) return;
  try {
    
const { Section } = window.PxuThemeSections;

class VideoSection extends Section {
  constructor($root) {
    super($root);
    this.$root = $root;
    this.$overlay = this.query('[data-pxu-video-overlay]');
    this.$btn = this.query('[data-pxu-video-btn]');
    this.$shopifyVideo = this.query('.pxu-video__video');
    this.id = $root.id;
    this.data = this.loadData();
    this.observer = null;

    this.onMount();
  }

  onMount() {
    this.initEventListeners();
    this.initIntersectionObserver();
  }

  onUnmount() {
    this.events.unregisterAll();
    this.observer.unobserve(this.$root);
  }

  initEventListeners() {
    if (this.$btn) {
      this.events.register(this.$btn, 'click', (e) => this.handleClick(e));
    }
  }

  initIntersectionObserver() {
    this.observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.initVideo();
          observer.unobserve(this.$root);
        }
      });
    }, { threshold: 0 });
    this.observer.observe(this.$root);
  }

  handleClick(e) {
    e.preventDefault();
    this.$overlay.style.opacity = 0;
    this.$overlay.style.pointerEvents = 'none';

    if (this.data.videoType === 'youtube') {
      const $video = this.query('[data-pxu-video-youtube');
      $video.src += '&autoplay=1';
    } else if (this.data.videoType === 'vimeo') {
      const $video = this.query('[data-pxu-video-vimeo]');
      $video.src += '&autoplay=1';
    } else if (this.data.videoType === 'shopify_hosted') {
      this.$shopifyVideo.play();
      this.$shopifyVideo.setAttribute('controls', '');
    }
  }

  initVideo() {
    switch (this.data.videoType) {
      case 'youtube':
        this.initYouTube();
        break;
      case 'vimeo':
        this.initVimeo();
        break;
      case 'shopify_hosted':
        if (this.data.enableVideoAutoplay) {
          this.$shopifyVideo.play();
        }
        break;
      default:
        console.error('Unsupported video type:', this.data.videoType);
    }
  }

  initYouTube() {
    if (this.data.videoType !== 'youtube') return;
    const $ytPlaceholder = this.query('[data-youtube-placeholder]');
    const ytAttributeString = $ytPlaceholder.dataset.attributeString;
    const ytTitle = $ytPlaceholder.dataset.title;
    $ytPlaceholder.innerHTML = `
      <iframe
        class="pxu-video__video"
        src="https://www.youtube.com/embed/${this.data.videoId}?${ytAttributeString}"
        allow="autoplay; encrypted-media"
        allowfullscreen
        title="${ytTitle}"
        data-pxu-video-youtube
      ></iframe>
    `;
  }

  initVimeo() {
    if (this.data.videoType !== 'vimeo') return;
    const $vimeoPlaceholder = this.query('[data-vimeo-placeholder]');
    const vimeoAttributeString = $vimeoPlaceholder.dataset.attributeString;
    $vimeoPlaceholder.innerHTML = `
      <iframe
        class="pxu-video__video"
        src="https://player.vimeo.com/video/${this.data.videoId}?${vimeoAttributeString}"
        allow="autoplay; encrypted-media"
        allowfullscreen
        data-pxu-video-vimeo
      ></iframe>
    `;
  }
}

document.querySelectorAll('[data-pxu-video]').forEach(($section) => {
  Section.init($section, VideoSection);
});

// export class for theme editor instance management
if (Shopify.designMode) {
  window.PxuThemeSections.VideoSection = VideoSection;
}

  } catch(e) { console.error(e); }
})();
})();
